import React from "react";
import { motion } from "framer-motion";

const stats = [
    
    { value: "4", label: "Countries Worked With" },
    { value: "1st", label: "Best AI · National Hackathon" },
];

const journey = [
    {
        phase: "The Foundation",
        title: "B.E. Computer Engineering",
        text: "Graduated with first division from IOE Purwanchal Campus, Dharan (2019–2024) — where I also mentored juniors in web development and captained the girls' cricket team.",
    },
    {
        phase: "The Craft",
        title: "Freelancing across borders",
        text: "Built frontends for Orange Publicity (California), CineArtLink (Hong Kong), and the Nepali startup N-Hub — shipping real products for real clients.",
    },
    {
        phase: "The Research",
        title: "AI meets engineering",
        text: "Built deep-learning systems for behaviour and drowsiness detection, and won 'Best AI' at a national-level hackathon conducted by DELTA-ERC.",
    },
    {
        phase: "The Now",
        title: "Masters student, remote developer",
        text: "Pursuing my Masters while working remotely as a frontend developer for a US-based company, building with Next.js and AWS.",
    },
];

const About = () => {
    return (
        <section className="section" id="aboutpage">
            <motion.h2
                className="section-title"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <span className="section-number">01.</span> About Me
            </motion.h2>

            <div className="about-layout">
                <motion.div
                    className="about-body"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                >
                    <p>
                        Hello! I'm Sabina, a computer engineer from Nepal who
                        found her happy place at the intersection of logic and
                        design. I'm currently pursuing my Masters degree while
                        working remotely as a frontend developer for a
                        US-based company.
                    </p>
                    <p>
                        My core tools these days are Next.js and AWS — I've
                        shipped ecommerce platforms with Stripe and PayPal
                        integrations, food ordering systems, and business
                        marketplaces. Beyond the frontend, I build
                        deep-learning systems in Python, from behaviour
                        analysis to drowsiness detection.
                    </p>
                    <div className="stats-row">
                        {stats.map((s) => (
                            <div key={s.label} className="stat-tile">
                                <span className="stat-value">{s.value}</span>
                                <span className="stat-label">{s.label}</span>
                            </div>
                        ))}
                    </div>
                </motion.div>

                <div className="journey">
                    {journey.map((step, i) => (
                        <motion.div
                            key={step.title}
                            className="journey-item"
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                        >
                            <div className="journey-marker" />
                            <p className="journey-phase">{step.phase}</p>
                            <h3 className="journey-title">{step.title}</h3>
                            <p className="journey-text">{step.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;
